import styled from 'styled-components'
import { Theme } from 'styles/Themes'

export default styled.button`
  display: flex;
  justify-content: center;
  align-items: center;

  margin-bottom: 20px;

  background-color: transparent;

  width: 180px;
  height: 50px;
  gap: 4px;

  border: 1px solid ${Theme.pallete.TERTIARY};
  border-radius: 5px;

  .showDetails-span {
    color: ${Theme.pallete.TERTIARY};
    text-align: center;
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: 'Inter';
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
  }

  .showDetails-img {
    width: 24px;
    height: 24px;
  }
`
